import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';
import { getConfig } from '@edx/frontend-platform';

export const createContact = async (data) => {
  let url = `${getConfig().LMS_BASE_URL}/blendxapi/hubspot/contact`;
  const { data: response } = await getAuthenticatedHttpClient().post(url, data);
  return response;
};